import VRangeSlider from './VRangeSlider';
export { VRangeSlider };
export default VRangeSlider;
//# sourceMappingURL=index.js.map